import { Analytics } from '@/utils/analytics';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { SvgProps } from 'react-native-svg';
import { TrackingData } from '@/utils/analytics/base-reporter';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  accessibilityLabel: string;
  disabled: boolean;
  Icon: React.ComponentType<SvgProps>;
  iconProps?: SvgProps;
  onPress: () => void;
  trackingData: TrackingData;
}

export const AttachmentListControlButton: React.FC<Props> = ({
  accessibilityLabel,
  disabled,
  Icon,
  iconProps,
  onPress,
  trackingData,
}) => {
  const theme = useTheme();

  return (
    <TouchableOpacity
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      disabled={disabled}
      onPress={() => {
        if (trackingData) {
          Analytics.track(
            `${trackingData.name}.press`,
            trackingData.properties,
          );
        }

        onPress();
      }}
      style={styles.controlButton}
    >
      <Icon
        fill={
          disabled ? theme.sk.color.icon.disabled : theme.sk.color.icon.primary
        }
        {...iconProps}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  controlButton: {
    alignItems: 'center',
    height: 32,
    justifyContent: 'center',
    width: 32,
  },
});
